import LayoutOffer from './LayoutOffer';

export default LayoutOffer;
